import type { Zone } from '@seek/audience-zones';

import { getProfileSuggestionsExperimentVariant } from 'src/modules/features/profileSuggestionsAbTest';

import type {
  AnalyticsProfileApproachabilityStatus,
  AnalyticsState,
} from '../types';

export interface ProfileState {
  candidateId?: string;
  profileVisibilityLevel?: string;
  profileApproachabilityStatus?: AnalyticsProfileApproachabilityStatus;
  profileViewedCount?: number;
  profileSearchAppearanceCount?: number;
}

const analyticsExperiments = ({
  zone,
  candidateId,
}: {
  zone?: Zone;
  candidateId?: string;
}) => {
  const experiments: AnalyticsState['experiments'] = [];

  if (zone && candidateId) {
    const profileSuggestionsExperimentVariant =
      getProfileSuggestionsExperimentVariant({
        zone,
        page: 'profile-page',
        candidateId,
      });

    if (profileSuggestionsExperimentVariant) {
      experiments.push({
        num: 3,
        id: 'centralised_nudge',
        variant: profileSuggestionsExperimentVariant,
      });
    }

    if (experiments.length) {
      return experiments;
    }
  }
};

export const profileReducer = (
  state: AnalyticsState,
  props: ProfileState,
): AnalyticsState => {
  const {
    profileVisibilityLevel = state.profileVisibilityLevel,
    candidateId = state.loginId,
    profileApproachabilityStatus = state.profileApproachabilityStatus,
    profileViewedCount = state.profileViewedCount,
    profileSearchAppearanceCount = state.profileSearchAppearanceCount,
  } = props;

  return {
    ...state,
    profileVisibilityLevel: profileVisibilityLevel
      ? profileVisibilityLevel?.toLowerCase()
      : 'not set',
    profileApproachabilityStatus,
    profileViewedCount,
    profileSearchAppearanceCount,
    loginId: candidateId,
    experiments: analyticsExperiments({
      zone: state.zone,
      candidateId,
    }),
  };
};
